@import "responsive";
@import "grid";

$yellow: #ffe300;
$cream: #faf8f5;
$black: #000000;
$yellow_opacity: rgba(255, 227, 0, 0.95);
$black_opacity: rgba(0, 0, 0, 0.7);
$grey: #9A9A9A;
$grey2: #707070;
$light_grey: #C6C6C6;
$white: #ffffff;



